import React, { useEffect, useRef } from 'react';

const RichText = ({ html, className, frameTitle = 'richtext' }) => {
  const htmlRef = useRef();
  let supportShadow = false; // !!document.body.attachShadow;

  useEffect(() => {
  }, [])

  useEffect(() => {
    if (supportShadow) {
      renderShadow(html);
    } else {
      renderIframe(html);
    }
  })

  const renderShadow = (content) => {
    if (content && htmlRef) {
      htmlRef.current.innerHTML = '';

      const div = document.createElement('div');
      const shadowRoot = div.attachShadow({mode: 'open'});

      shadowRoot.innerHTML = `
        <style>
          div, p { 
            all: initial; 
            display: inherit;
          }
        </style>
        ${content}
      `;

      htmlRef.current.appendChild(div);
    }
  };

  const renderIframe = (content) => {
    if (content && htmlRef) {
      const frame = htmlRef.current;
      const { document: doc } = frame.contentWindow;

      doc.body.innerHTML = '';
      frame.style.height = '0px';

      const div = doc.createElement('div');
      div.innerHTML = content;
      doc.body.appendChild(div);

      // const contentDocument = frame.contentDocument;
      // contentDocument.open();
      // contentDocument.write(content);
      // contentDocument.close();

      setTimeout(function () {
        // console.log('height', doc.body.scrollHeight)
        frame.style.width = '100%';
        frame.style.height = `${doc.body.scrollHeight}px`;
      }, 1000);
    }
  };

  return supportShadow 
    ? <div className={className} ref={htmlRef}></div> 
    : <iframe src="about:blank" scrolling="no" className={className} ref={htmlRef} frameBorder="0" title={frameTitle}></iframe>;
};

export default RichText;

// const RichText = ({ html, className, frameTitle = 'richtext' }) => {
//   const htmlRef = useRef();
//   let supportShadow = false; // !!document.body.attachShadow;

//   useEffect(() => {
//   }, [])

//   useEffect(() => {
//     if (supportShadow) {
//       renderShadow(html);
//     } else {
//       renderIframe(html);
//     }
//   })

//   const renderShadow = (content) => {
//     if (content && htmlRef) {
//       htmlRef.current.innerHTML = '';

//       const div = document.createElement('div');
//       const shadowRoot = div.attachShadow({mode: 'open'});

//       shadowRoot.innerHTML = `
//         <style>
//           div, p { 
//             all: initial; 
//             display: inherit;
//           }
//         </style>
//         ${content}
//       `;

//       htmlRef.current.appendChild(div);
//     }
//   };

//   const renderIframe = (content) => {
//     if (content && htmlRef) {
//       htmlRef.current.innerHTML = '';

//       const iframe = document.createElement('iframe');

//       iframe.onload = () => {
//         setTimeout(() => {
//           iframe.style.width = '100%';
//           iframe.style.height = doc.documentElement.scrollHeight + 'px';
//         });
//       }
//       iframe.scroll = false;
//       // iframe.style.cssText = `
//       //   height: 0;
//       //   overflow: hidden;
//       //   border: 0 none;
//       // `;

//       htmlRef.current.appendChild(iframe);

//       const {
//         contentWindow: {
//           document: doc
//         }
//       } = iframe;

//       doc.body.innerHTML = content;
//     }
//   };

//   return <div className={className} ref={htmlRef}></div>
// };

// export default RichText;
